import * as React from "react";

import { cn } from "@/lib/utils";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  prefixIcon?: React.ReactNode;
  suffixIcon?: React.ReactNode;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, prefixIcon, suffixIcon, ...props }, ref) => {
    return (
      <div className="relative h-full w-full">
        {prefixIcon && (
          <div className="absolute left-1.5 top-1/2 -translate-y-1/2 transform">
            {prefixIcon}
          </div>
        )}
        <input
          type={type}
          className={cn(
            "flex h-full w-full rounded-md border border-input bg-stg-grey-2 px-3 py-1 text-base text-stg-grey-4 shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
            className,
          )}
          ref={ref}
          {...props}
        />
        {suffixIcon && (
          <div className="absolute right-[20px] top-1/2 -translate-y-1/2 transform">
            {suffixIcon}
          </div>
        )}
      </div>
    );
  },
);
Input.displayName = "Input";

export { Input };
